import {
  Box,
  FormControlLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LIBRE_AHORRA_BUNDLE, MANDATORY_FIELD_ERR } from '../../../constants';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { isBundle } from '../../commonCode';
import { CaptureLoanDetailsStyles as radioClass } from '../../Consumer/CaptureLoanDetailsStyles';
import { commonUtility } from '../UtilityFunctions';
import { CDProcessingStyles as classes } from './CDProcessingStyles';

export const FundingScreenCards = ({ accountsResponse, setIsSubmitClicked, isSubmitClicked }) => {
  const {
    setOrientalAccountCardValue,
    orientalAccountCardValue,
    setFundData,
    setFundDataErrors,
    fundData,
    fundDataErrors,
    customerNumber,
    setIsFundingScreenDirty,
    setIsScreenOneDirty,
    setIsScreenTwoDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsOffersScreenDirty,
    islibrePlusJourney,
    productName,
    theme,
  } = useContext(LeadGenerationContext);
  const { t } = useTranslation();

  const [radioValue, setRadioValue] = useState('');

  useEffect(() => {
    if (orientalAccountCardValue) {
      setRadioValue(orientalAccountCardValue?.Id);
    }
  }, [orientalAccountCardValue]);

  const handleRadioChange = (e) => {
    if (e.target.value) {
      setIsOffersScreenDirty(true);
      setIsFundingScreenDirty(true);
      setRadioValue(e.target.value);
      setIsScreenOneDirty(true);
      setIsScreenTwoDirty(true);
      setIsScreenThreeDirty(true);
      setIsScreenFourDirty(true);
      setIsScreenFiveDirty(true);
      const accountVal = accountsResponse.find((x) => x.Id === e.target.value);
      setFundData({
        ...fundData,
        accountNumber: commonUtility(accountVal.AccountNumber),
        typeOfAccount: commonUtility(accountVal.AccountType),
      });
      setOrientalAccountCardValue(accountVal);
      setIsSubmitClicked(false);
      setFundDataErrors({
        ...fundDataErrors,
        accountNumber: '',
        depositAmount: '',
        typeOfAccount: '',
      });
    } else if (e.target.value === '') {
      setFundData({ ...fundData, accountNumber: '' });
      setFundDataErrors({ ...fundDataErrors, accountNumber: MANDATORY_FIELD_ERR });
    }
  };

  return (
    <Box component="div" sx={classes.marginSpacing}>
      <Box component="div" sx={[radioClass.radioContainer, classes.radioLabelContainer]}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name="accountNumber"
          id="accountNumber_id"
          data-testId="accountNumber_id"
          value={radioValue.toString()}
          sx={classes.radioGroupRow}
          onChange={handleRadioChange}
        >
          <Grid container size={{ xs: 12 }} spacing={4}>
            {accountsResponse?.map((accountData) => (
              <Grid
                size={{ xs: 12, md: 6, lg: isBundle(productName) ? 6 : 4 }}
                key={accountData.Id}
              >
                <Box
                  component="div"
                  sx={{
                    borderRadius: '10px',
                    height: '100%',
                    width: '100%',

                    ...(isBundle(productName)
                      ? {
                          backgroundColor: theme?.palette?.fieldsBackground?.main,
                          border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                          padding: '10px 0px 5px 0',
                        }
                      : {
                          background:
                            accountData.isDepositeError || accountData.isValid
                              ? `#E4E9F2`
                              : 'inherit',
                          border:
                            accountData.isDepositeError || accountData.isValid
                              ? `#E4E9F2`
                              : '1px solid #E6E6E6',
                          padding: '10px 15px 5px 0',
                        }),

                    pointerEvents:
                      accountData.isDepositeError || accountData.isValid ? 'none' : 'auto',
                    opacity: accountData.isDepositeError || accountData.isValid ? 0.6 : 1,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Radio
                        color="default"
                        sx={[
                          { ...radioClass.radioRoot, color: theme?.palette?.orientalPrimary?.main },
                          classes.radioMargin,
                        ]}
                        size="medium"
                        value={accountData.Id.toString()}
                        inputProps={{
                          'data-testid': 'debtConsolidation_testid',
                        }}
                        id={accountData.Id}
                        name={accountData.Id}
                        onClick={handleRadioChange}
                        disabled={
                          (isSubmitClicked &&
                            fundDataErrors?.accountNumber?.includes('available balance') &&
                            accountData.Id === orientalAccountCardValue.Id) ||
                          accountData.isDepositeError ||
                          accountData.isValid
                        }
                      />
                    }
                    sx={[classes.radioCard, classes.cardStyle]}
                    label={
                      <InputLabel htmlFor="test" sx={radioClass.radioLabelStyle}>
                        <Typography
                          sx={
                            isBundle(productName)
                              ? {
                                  fontSize: '8px',
                                  fontWeight: 700,
                                  color: theme?.palette?.primary?.main,
                                }
                              : classes.radioBtnLabel1
                          }
                        >
                          {t(accountData?.AccountType, {
                            defaultValue: accountData?.AccountType,
                            nsSeparator: '|',
                          })}
                        </Typography>

                        <Box sx={{ display: 'flex' }}>
                          <Typography
                            sx={
                              isBundle(productName)
                                ? {
                                    fontSize: '16px !important',
                                    fontWeight: '400',
                                    color: theme?.palette?.subtext?.main,
                                  }
                                : classes.radioBtnLabel2
                            }
                          >
                            XXXX-XXXX-{`${accountData?.AccountNumber?.slice(-4)}`}
                          </Typography>
                          {(customerNumber !== '' || islibrePlusJourney) && accountData?.Balance ? (
                            <Box
                              component="span"
                              sx={{
                                ...classes.radioBtnLabel3,
                                fontSize: '16px !important',
                                color: theme?.palette?.primary?.main,
                              }}
                            >
                              {' '}
                              - $ {accountData?.Balance}
                            </Box>
                          ) : (
                            <Box component="span" sx={classes.radioBtnLabel3}>
                              {' '}
                            </Box>
                          )}
                        </Box>
                      </InputLabel>
                    }
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      </Box>
      <div>
        {' '}
        <Box component="span" sx={classes.error_message} role="alert" data-testid="offers-error">
          {t(fundDataErrors?.accountNumber, {
            defaultValue: fundDataErrors?.accountNumber,
          })}
        </Box>
      </div>
    </Box>
  );
};

FundingScreenCards.propTypes = {
  accountsResponse: PropTypes.object,
  setIsSubmitClicked: PropTypes.func,
  isSubmitClicked: PropTypes.bool,
};
